module.exports = __webpack_public_path__ + "static/media/ic_premium_onboarding_mid.d8f277ee.svg";